import React from "react";

type SvgProps = React.SVGProps<SVGSVGElement>;

export const SupportTeam = (props: SvgProps) => (
  <svg
    {...props}
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.456522"
      y="0.456522"
      width="41.087"
      height="41.087"
      rx="20.5435"
      fill="white"
    />
    <rect
      x="0.456522"
      y="0.456522"
      width="41.087"
      height="41.087"
      rx="20.5435"
      stroke="#F3F3F5"
      stroke-width="0.913043"
    />
    <g clip-path="url(#clip0_6719_8069)">
      <path
        d="M27.842 28.2281V30.1303H14.1464V28.2281C14.1464 26.3404 15.6826 24.8042 17.5703 24.8042H24.4181C26.3059 24.8042 27.842 26.3404 27.842 28.2281ZM17.0925 14.9335C18.2559 13.8431 19.7791 13.3044 21.3762 13.4034C24.3618 13.5966 26.7015 16.195 26.7015 19.3184C26.7015 20.6651 25.6066 21.76 24.2599 21.76H22.4292C22.2436 21.1292 21.6668 20.6651 20.976 20.6651C20.1352 20.6651 19.4542 21.3461 19.4542 22.1868C19.4542 23.0276 20.1352 23.7086 20.976 23.7086C21.3853 23.7086 21.7559 23.545 22.029 23.2817H24.2599C26.4451 23.2817 28.2232 21.5036 28.2232 19.3184C28.2225 15.3953 25.2581 12.1297 21.4736 11.8854C19.4466 11.7538 17.5239 12.4424 16.0516 13.8241C14.6919 15.0986 13.8748 16.8645 13.7766 18.718H15.3006C15.3942 17.2701 16.0219 15.937 17.0925 14.9335ZM23.3529 20.239H24.3938C24.775 20.239 25.1082 19.959 25.1524 19.5801C25.2041 19.1335 25.1851 18.6655 25.0831 18.1869C24.7453 16.6051 23.4617 15.3291 21.8776 15.0035C19.1864 14.4503 16.811 16.5024 16.811 19.0977C16.811 20.2154 17.2515 21.2319 17.9675 21.9829C18.0512 20.3767 19.3682 19.0969 20.995 19.0969C21.9522 19.0969 22.7952 19.5474 23.3529 20.2382V20.239Z"
        fill="#A09CAD"
      />
    </g>
    <defs>
      <clipPath id="clip0_6719_8069">
        <rect
          width="18.2609"
          height="18.2609"
          fill="white"
          transform="translate(11.8695 11.8696)"
        />
      </clipPath>
    </defs>
  </svg>
);
